// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card{background-color:var(--background-2);padding:24px;display:flex;flex-direction:column;align-items:center;position:relative}.card:last-child{border-bottom:unset}.card__title{margin-bottom:24px}.card__description{font-size:.875rem;line-height:1.5rem;color:var(--body-2);font-weight:300;text-align:center}@media screen and (min-width:48em){.card{margin-bottom:24px;border-radius:4px;border-bottom:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
